import { render, staticRenderFns } from "./licensing-indicator.vue?vue&type=template&id=30ec563e&"
import script from "./licensing-indicator.vue?vue&type=script&lang=js&"
export * from "./licensing-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports